import React from "react";
import { ReactI18NextChild } from "react-i18next";

interface Props {
	className?: string;
	width?: "fill" | "xl" | "lg" | "md" | "sm" | "xs" | "none";
	children?: ReactI18NextChild | Iterable<ReactI18NextChild>;
	ariaLabel?: string;
}

export default function CardColumn({
	className,
	width = "md",
	children,
	ariaLabel,
}: Props) {
	return (
		<div
			className={`${className ? className : ""} col-width-${width}`}
			aria-label={ariaLabel}>
			{children}
		</div>
	);
}
